import React from 'react';
import { GOOGLE_DRIVE, ONE_DRIVE, BOX, DROP_BOX } from 'Api/drives.constants';
import intl from 'react-intl-universal';
import {store} from 'Store/store.index';
import './DrivesListDlg.scss';
import {
  OPEN_FILE_FROM_GOOGLE_DRIVE,
  OPEN_FILE_FROM_ONE_DRIVE,
  OPEN_FILE_FROM_BOX,
  OPEN_FILE_FROM_DROPBOX,
} from 'Components/viewer/ui/constants/openfile.constants';
import {
  SAVE_TO_GOOGLE_DRIVE,
  SAVE_TO_ONE_DRIVE,
  SAVE_TO_BOX,
  SAVE_TO_DROPBOX,
} from 'Components/viewer/ui/constants/savefile.constants';

export default class DrivesListDlg extends React.Component {
  constructor(props) {
    super(props);

    this.OpenFromDrive = intl.formatMessage({ id: 'DrivesListDlg.OpenFromDrive' });
    this.SaveToDrive = intl.formatMessage({ id: 'DrivesListDlg.SaveToDrive' });
    this.OpenFromOneDrive = intl.formatMessage({ id: 'DrivesListDlg.OpenFrom' }, { name: 'OneDrive' });
    this.OpenFromDropBox = intl.formatMessage({ id: 'DrivesListDlg.OpenFrom' }, { name: 'DropBox' });
    this.OpenFromBox = intl.formatMessage({ id: 'DrivesListDlg.OpenFrom' }, { name: 'Box' });
    this.OpenFromGoogleDrive = intl.formatMessage({ id: 'DrivesListDlg.OpenFrom' }, { name: 'Google Drive' });
    this.SaveToOneDrive = intl.formatMessage({ id: 'DrivesListDlg.SaveTo' }, { name: 'OneDrive' });
    this.SaveToDropBox = intl.formatMessage({ id: 'DrivesListDlg.SaveTo' }, { name: 'DropBox' });
    this.SaveToBox = intl.formatMessage({ id: 'DrivesListDlg.SaveTo' }, { name: 'Box' });
    this.SaveToGoogleDrive = intl.formatMessage({ id: 'DrivesListDlg.SaveTo' }, { name: 'Google Drive' });

    this.state = {};
  }
  onShowDriveModal = (driveName, gaName) => {
    this.props.onCancel();
    this.props.onShowDriveDlg({ driveName, driveOperateType: this.props.type });
    store.userStore.doSendGAEvent({ eventKey: gaName, label: 'home_tab' });
  };
  render() {
    let drives = [];
    const drivesForOpen = [
      {
        driveName: ONE_DRIVE,
        title: `${this.OpenFromOneDrive}`,
        iconClass: 'one-drive',
        gaName: OPEN_FILE_FROM_ONE_DRIVE,
      },
      {
        driveName: DROP_BOX,
        title: `${this.OpenFromDropBox}`,
        iconClass: 'dropbox',
        gaName: OPEN_FILE_FROM_DROPBOX,
      },
      {
        driveName: BOX,
        title: `${this.OpenFromBox}`,
        iconClass: 'box',
        gaName: OPEN_FILE_FROM_BOX,
      },
      {
        driveName: GOOGLE_DRIVE,
        title: `${this.OpenFromGoogleDrive}`,
        iconClass: 'google-drive',
        gaName: OPEN_FILE_FROM_GOOGLE_DRIVE,
      },
    ];
    const drivesFoSave = [
      {
        driveName: ONE_DRIVE,
        title: `${this.SaveToOneDrive}`,
        iconClass: 'one-drive',
        gaName: SAVE_TO_ONE_DRIVE,
      },
      {
        driveName: DROP_BOX,
        title: `${this.SaveToDropBox}`,
        iconClass: 'dropbox',
        gaName: SAVE_TO_DROPBOX,
      },
      {
        driveName: BOX,
        title: `${this.SaveToBox}`,
        iconClass: 'box',
        gaName: SAVE_TO_BOX,
      },
      {
        driveName: GOOGLE_DRIVE,
        title: `${this.SaveToGoogleDrive}`,
        iconClass: 'google-drive',
        gaName: SAVE_TO_GOOGLE_DRIVE,
      },
    ];
    const { invisibleOpenSaveBtn } = store.userStore;
    const filterBtn = [];

    if (invisibleOpenSaveBtn.indexOf(OPEN_FILE_FROM_ONE_DRIVE) > -1) {
      filterBtn.push(ONE_DRIVE);
    }
    if (invisibleOpenSaveBtn.indexOf(OPEN_FILE_FROM_BOX) > -1) {
      filterBtn.push(BOX);
    }
    if (invisibleOpenSaveBtn.indexOf(OPEN_FILE_FROM_DROPBOX) > -1) {
      filterBtn.push(DROP_BOX);
    }
    if (invisibleOpenSaveBtn.indexOf(OPEN_FILE_FROM_GOOGLE_DRIVE) > -1) {
      filterBtn.push(GOOGLE_DRIVE);
    }

    if (this.props.type === 'open') {
      drives = drivesForOpen.filter((item) => {
        if (filterBtn.indexOf(item.driveName) < 0) {
          return true;
        }
      });
    } else {
      drives = drivesFoSave.filter((item) => {
        if (filterBtn.indexOf(item.driveName) < 0) {
          return true;
        }
      });
    }
    return (
      <React.Fragment>
        <div className="drives-list-wrapper list-dlg">
          <div className="header">
            <i className="back-btn icon" onClick={this.props.onCancel}/>
            {this.props.type === 'open' ? this.OpenFromDrive : this.SaveToDrive}
          </div>
          <div className="list-body">
            {drives.map((item, index) => {
              return (
                <div key={index} className="drive-wrapper" onClick={this.onShowDriveModal.bind(this, item.driveName, item.gaName)}>
                  <i className={`${item.iconClass} drive-icon`} />
                  {item.title}
                </div>
              );
            })}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
